const type = 'advanced'
const path =
  '/advance/react-java/java-server/java-main/src/main/java/com/example/controller/'
const name = 'AcdcController.java'

const conditions = [
  {
    type: 'different',
    option: 'frontend',
    value: 'html',
  },
]

export { type, path, name, conditions }
